// Construction Phase Icons
// For use with constructionPhaseSummaries.js util

const baseProps = (size, color, props) => ({
  width: size,
  height: size,
  viewBox: "0 0 36 36",
  fill: "none",
  stroke: color,
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  ...props,
});

export const InDevelopmentIcon = ({
  size = 36,
  color = "currentColor",
  ...props
}) => (
  <svg {...baseProps(size, color, props)} viewBox="0 0 64 64">
    <path
      d="m32 60h-22c-1.1 0-2-.9-2-2v-20l13-11 13 11v20c0 1.1-.9 2-2 2z"
      fill="#749dd1"
    ></path>
    <path d="m16 48h10v12h-10z" fill="#d3dce5"></path>
    <path
      d="m38 38-2.65 3-14.35-12.67-14.35 12.67-2.65-3 17-15z"
      fill="#5064aa"
    ></path>
    <path
      d="m8 9h-3c-.55 0-1-.45-1-1s.45-1 1-1h3c.55 0 1 .45 1 1s-.45 1-1 1z"
      fill="#d85363"
    ></path>
    <path
      d="m52 8c0 2.21-1.79 4-4 4h-35l-5.7-2.85c-.95-.47-.95-1.83 0-2.3l5.7-2.85h35c1.1 0 2.1.45 2.83 1.17.72.73 1.17 1.73 1.17 2.83z"
      fill="#ecc865"
    ></path>
    <path d="m13 4v8l-5.7-2.85c-.95-.47-.95-1.83 0-2.3z" fill="#d85363"></path>
    <path
      d="m44 4h4c2.21 0 4 1.79 4 4 0 2.21-1.79 4-4 4h-4z"
      fill="#d85363"
    ></path>
    <rect fill="#ecc865" height="40" rx="2" width="14" x="46" y="20"></rect>
    <g fill="#ecaf64">
      <path d="m60 23v2h-4c-.55 0-1-.45-1-1s.45-1 1-1z"></path>
      <path d="m60 27v2h-6c-.55 0-1-.45-1-1s.45-1 1-1z"></path>
      <path d="m60 31v2h-4c-.55 0-1-.45-1-1s.45-1 1-1z"></path>
      <path d="m60 35v2h-6c-.55 0-1-.45-1-1s.45-1 1-1z"></path>
      <path d="m60 39v2h-4c-.55 0-1-.45-1-1s.45-1 1-1z"></path>
      <path d="m60 43v2h-6c-.55 0-1-.45-1-1s.45-1 1-1z"></path>
      <path d="m60 47v2h-4c-.55 0-1-.45-1-1s.45-1 1-1z"></path>
      <path d="m60 51v2h-6c-.55 0-1-.45-1-1s.45-1 1-1z"></path>
      <path d="m60 55v2h-4c-.55 0-1-.45-1-1s.45-1 1-1z"></path>
    </g>
    <circle cx="21" cy="39" fill="#d3dce5" r="3"></circle>
  </svg>
);

export const PlanningPermittingIcon = ({
  size = 36,
  color = "currentColor",
  ...props
}) => (
  <svg
    {...baseProps(size, color, props)}
    clipRule="evenodd"
    fillRule="evenodd"
    viewBox="0 0 1707 1707"
  >
    <g id="Layer_x0020_1">
      <path
        d="m1495 1602h-894c-16 0-30-14-30-30 0-17 14-30 30-30h5l-10-199c-14-2-25-14-25-29v-789c0-15 12-28 28-30v-288c-16-2-28-14-28-30v-146c0-16 14-30 30-30h1035c16 0 30 14 30 30v1401c0 93-77 170-171 170z"
        fill="#ffe4af"
      ></path>
      <path
        d="m1495 1602h-985c-88 0-159-71-159-159s71-159 159-159h985c-87 0-159 71-159 159s72 159 159 159z"
        fill="#ffc06d"
      ></path>
      <path
        d="m1499 1207h-761c-17 0-30-13-30-30v-509c0-16 13-30 30-30h761c17 0 30 14 30 30v509c0 17-13 30-30 30z"
        fill="#333"
      ></path>
      <path d="m1489 1167v-489h-741v489z" fill="#ffa721"></path>
      <g id="_675378688" fill="#333">
        <path d="m708 940v-34h588c10 0 17 8 17 17s-7 17-17 17h-262v119c0 10-8 17-17 17s-17-7-17-17v-119z"></path>
        <path d="m1352 1207h-33v-147c0-9 7-17 16-17 10 0 17 8 17 17z"></path>
        <path d="m1102 638h33v167c0 9-7 16-17 16-9 0-16-7-16-16z"></path>
      </g>
      <path
        d="m709 435h-589c-16 0-30-14-30-30 0-151 107-284 254-317 9-2 19 0 26 6s11 14 11 23v48h68v-48c0-9 4-17 11-23s16-8 25-6c147 33 254 166 254 317 0 16-13 30-30 30z"
        fill="#ffa721"
      ></path>
      <g fill="#333">
        <path d="m479 225h-128c-17 0-30-14-30-30v-164c0-16 13-30 30-30h128c16 0 30 14 30 30v164c0 16-14 30-30 30zm280 330h-688c-17 0-30-13-30-30v-87c0-16 13-30 30-30h688c16 0 30 14 30 30v87c0 17-14 30-30 30z"></path>
        <path d="m1499 304c9 0 17-7 17-17 0-9-8-16-17-16h-683c-9 0-17 7-17 16 0 10 8 17 17 17z"></path>
        <path d="m1499 424c9 0 17-8 17-17s-8-17-17-17h-623c-9 0-17 8-17 17s8 17 17 17z"></path>
        <path d="m1499 543c9 0 17-7 17-16s-8-17-17-17h-623c-9 0-17 8-17 17s8 16 17 16z"></path>
        <path d="m1358 184c9 0 16-7 16-16s-7-17-16-17h-479c-9 0-17 8-17 17s8 16 17 16z"></path>
        <path d="m1335 1705h-963c-17 0-30-13-30-30 0-16 13-30 30-30h963c16 0 30 14 30 30 0 17-14 30-30 30zm341-103h-1645c-17 0-30-14-30-30 0-17 13-30 30-30h1645c17 0 30 13 30 30 0 16-13 30-30 30z"></path>
      </g>
    </g>
  </svg>
);

export const FoundationIcon = ({
  size = 36,
  color = "currentColor",
  ...props
}) => (
  <svg {...baseProps(size, color, props)} viewBox="0 0 512 512.01683">
    <path
      d="m8.835938 247.1875h123.585937c4.875 0 8.828125 3.953125 8.828125 8.828125v70.621094c0 4.875-3.953125 8.828125-8.828125 8.828125h-123.585937c-4.875 0-8.8281255-3.953125-8.8281255-8.828125v-70.621094c0-4.875 3.9531255-8.828125 8.8281255-8.828125zm0 0"
      fill="#c2615f"
    ></path>
    <path
      d="m212.488281 247.1875h-62.410156c-4.875 0-8.828125 3.953125-8.828125 8.828125v70.621094c0 4.875 3.953125 8.828125 8.828125 8.828125h123.585937c4.875 0 8.828126-3.953125 8.828126-8.828125v-58.527344zm0 0"
      fill="#f0785a"
    ></path>
    <path
      d="m380.742188 247.1875h34.164062c4.875 0 8.828125 3.953125 8.828125 8.828125v70.621094c0 4.875-3.953125 8.828125-8.828125 8.828125h-123.585938c-4.875 0-8.828124-3.953125-8.828124-8.828125v-58.527344zm0 0"
      fill="#c2615f"
    ></path>
    <path
      d="m79.457031 335.464844h123.585938c4.875 0 8.828125 3.953125 8.828125 8.828125v70.621093c0 4.875-3.953125 8.828126-8.828125 8.828126h-123.585938c-4.875 0-8.828125-3.953126-8.828125-8.828126v-70.621093c0-4.875 3.953125-8.828125 8.828125-8.828125zm0 0"
      fill="#cc4b4c"
    ></path>
    <path
      d="m220.699219 335.464844h123.585937c4.875 0 8.828125 3.953125 8.828125 8.828125v70.621093c0 4.875-3.953125 8.828126-8.828125 8.828126h-123.585937c-4.875 0-8.828125-3.953126-8.828125-8.828126v-70.621093c0-4.875 3.953125-8.828125 8.828125-8.828125zm0 0"
      fill="#802f34"
    ></path>
    <path
      d="m361.9375 335.464844h123.589844c4.875 0 8.824218 3.953125 8.824218 8.828125v70.621093c0 4.875-3.949218 8.828126-8.824218 8.828126h-123.589844c-4.875 0-8.824219-3.953126-8.824219-8.828126v-70.621093c0-4.875 3.949219-8.828125 8.824219-8.828125zm0 0"
      fill="#cc4b4c"
    ></path>
    <path
      d="m8.835938 423.742188h123.585937c4.875 0 8.828125 3.949218 8.828125 8.828124v70.617188c0 4.878906-3.953125 8.828125-8.828125 8.828125h-123.585937c-4.875 0-8.8281255-3.949219-8.8281255-8.828125v-70.617188c0-4.878906 3.9531255-8.828124 8.8281255-8.828124zm0 0"
      fill="#c2615f"
    ></path>
    <path
      d="m150.078125 423.742188h123.585937c4.875 0 8.828126 3.949218 8.828126 8.828124v70.617188c0 4.878906-3.953126 8.828125-8.828126 8.828125h-123.585937c-4.875 0-8.828125-3.949219-8.828125-8.828125v-70.617188c0-4.878906 3.953125-8.828124 8.828125-8.828124zm0 0"
      fill="#f0785a"
    ></path>
    <path
      d="m291.320312 423.742188h123.585938c4.875 0 8.828125 3.949218 8.828125 8.828124v70.617188c0 4.878906-3.953125 8.828125-8.828125 8.828125h-123.585938c-4.875 0-8.828124-3.949219-8.828124-8.828125v-70.617188c0-4.878906 3.953124-8.828124 8.828124-8.828124zm0 0"
      fill="#c2615f"
    ></path>
    <path
      d="m390.683594 245.078125-175.132813 37.246094c-4.445312.839843-8.980469-.917969-11.699219-4.539063-2.714843-3.617187-3.132812-8.464844-1.082031-12.5l84.746094-157.714844c1.898437-3.347656 5.386719-5.492187 9.234375-5.671874 3.851562-.175782 7.523438 1.628906 9.726562 4.789062l90.386719 120.4375c2.414063 3.003906 3.121094 7.039062 1.863281 10.683594-1.253906 3.644531-4.292968 6.390625-8.042968 7.269531zm0 0"
      fill="#bdc3c7"
    ></path>
    <path
      d="m308.207031 208.347656c-3.800781 0-7.175781-2.429687-8.375-6.035156-1.203125-3.605469.039063-7.574219 3.078125-9.855469l68.960938-51.726562c3.453125-2.589844 5.382812-6.734375 5.136718-11.046875l-.882812-15.886719c-.578125-10.207031 3.992188-20.019531 12.171875-26.148437l25.46875-19.128907c2.523437-1.894531 5.863281-2.296875 8.765625-1.054687 2.898438 1.238281 4.917969 3.929687 5.296875 7.058594.375 3.132812-.945313 6.226562-3.46875 8.121093l-25.46875 19.109375c-3.457031 2.589844-5.390625 6.738282-5.144531 11.054688l.882812 15.886718c.582032 10.207032-3.988281 20.023438-12.175781 26.148438l-68.960937 51.738281c-1.523438 1.148438-3.378907 1.769531-5.285157 1.765625zm0 0"
      fill="#95a5a5"
    ></path>
    <path
      d="m413.074219 52.871094 65.773437-49.339844c7.796875-5.847656 18.863282-4.269531 24.714844 3.53125l4.90625 6.539062c5.851562 7.800782 4.273438 18.867188-3.527344 24.71875l-65.773437 49.335938c-3.898438 2.925781-9.433594 2.136719-12.359375-1.765625l-15.5-20.660156c-2.925782-3.902344-2.132813-9.433594 1.765625-12.359375zm0 0"
      fill="#f29c1f"
    ></path>
    <g fill="#fb7b76">
      <path d="m35.320312 282.5c0 4.875-3.953124 8.828125-8.828124 8.828125h-26.4843755v-17.65625h26.4843755c4.875 0 8.828124 3.953125 8.828124 8.828125zm0 0"></path>
      <path d="m97.113281 291.328125h-35.3125c-4.875 0-8.828125-3.953125-8.828125-8.828125s3.953125-8.828125 8.828125-8.828125h35.3125c4.875 0 8.824219 3.953125 8.824219 8.828125s-3.949219 8.828125-8.824219 8.828125zm0 0"></path>
    </g>
  </svg>
);

export const FramingIcon = ({
  size = 36,
  color = "currentColor",
  ...props
}) => (
  <svg {...baseProps(size, color, props)} viewBox="0 0 60 60">
    <g fill="#934e41">
      <path d="m7 27h14v4h-14z"></path>
      <path d="m7 43h14v4h-14z"></path>
      <path d="m39 27h14v4h-14z"></path>
      <path d="m39 43h14v4h-14z"></path>
    </g>
    <path d="m28 4h4v30h-4z" fill="#aa5d43"></path>
    <path d="m21 32h18v4h-18z" fill="#934e41"></path>
    <path d="m19 14.263v40.737h4v-44.8z" fill="#aa5d43"></path>
    <path d="m37 10.2v44.8h4v-40.737z" fill="#aa5d43"></path>
    <path d="m51 23.15v31.85h4v-27.618z" fill="#aa5d43"></path>
    <path d="m9 23.15v31.85h-4v-27.618z" fill="#aa5d43"></path>
    <path
      d="m55.952 29.734-25.952-24.012-25.952 24.012c-.405.375-1.039.352-1.416-.052l-1.364-1.463c-.377-.404-.353-1.036.052-1.411l27.316-25.274c.769-.711 1.959-.711 2.728 0l27.316 25.273c.405.375.429 1.007.052 1.411l-1.364 1.463c-.376.404-1.01.427-1.416.052z"
      fill="#b76c4b"
    ></path>
    <rect fill="#b76c4b" height="6" rx="1" width="58" x="1" y="53"></rect>
  </svg>
);

export const RoughInIcon = ({
  size = 36,
  color = "currentColor",
  ...props
}) => (
  <svg
    {...baseProps(size, color, props)}
    enable-background="new 0 0 512 512"
    viewBox="0 0 512 512"
  >
    <g>
      <g>
        <path
          d="m412.2 437.8h-27c-7.1 0-12.8-5.8-12.8-12.8v-192.2c0-7.1 5.8-12.8 12.8-12.8h27c-7.1 0-12.8 5.7-12.8 12.8v192.2c.1 7 5.8 12.8 12.8 12.8z"
          fill="#f8d275"
        ></path>
      </g>
      <g>
        <path
          d="m500.4 232.8v192.2c0 7.1-5.7 12.8-12.8 12.8h-75.4c-7.1 0-12.8-5.8-12.8-12.8v-192.2c0-7.1 5.7-12.8 12.8-12.8h75.4c7.1 0 12.8 5.7 12.8 12.8z"
          fill="#f3e379"
        ></path>
      </g>
      <g>
        <g>
          <path d="m234.1 12.6h33.6v118.2h-33.6z" fill="#718dd0"></path>
        </g>
        <g>
          <path d="m234.1 164.4h33.6v335h-33.6z" fill="#718dd0"></path>
        </g>
      </g>
      <g>
        <g>
          <path d="m296.2 164.4h33.6v335h-33.6z" fill="#718dd0"></path>
        </g>
      </g>
      <g>
        <path
          d="m511.4 130.8h-305.7v-118.2h-33.7v135.1c0 9.3 7.5 16.8 16.8 16.8h230.7v55.5h33.6v-55.6h58.2v-33.6z"
          fill="#d65f68"
        ></path>
      </g>
      <g>
        <path
          d="m188.9 191.6h-188.3v33.6h56v56.5h33.6v-56.5h81.9v274.3h33.6v-291.1c0-9.3-7.6-16.8-16.8-16.8z"
          fill="#d65f68"
        ></path>
      </g>
      <g>
        <path d="m391.5 241.3h10.7v77.8h-10.7z" fill="#e8ecf0"></path>
      </g>
      <g>
        <path d="m402.2 241.3h25v77.8h-25z" fill="#f2f4f6"></path>
      </g>
      <g>
        <path d="m391.5 337.1h10.7v79.5h-10.7z" fill="#e8ecf0"></path>
      </g>
      <g>
        <path d="m402.2 337.1h25v79.5h-25z" fill="#f2f4f6"></path>
      </g>
      <g>
        <path d="m445.6 241.3h10.7v77.8h-10.7z" fill="#e8ecf0"></path>
      </g>
      <g>
        <path d="m456.3 241.3h25.1v77.8h-25.1z" fill="#f2f4f6"></path>
      </g>
      <g>
        <path d="m445.6 337.1h10.7v79.5h-10.7z" fill="#e8ecf0"></path>
      </g>
      <g>
        <path d="m456.3 337.1h25.1v79.5h-25.1z" fill="#f2f4f6"></path>
      </g>
      <g>
        <path
          d="m50.3 499.4h-28.1c-7.1 0-12.8-5.7-12.8-12.8v-192.1c0-7.1 5.8-12.8 12.8-12.8h28.1c-7.1 0-12.8 5.8-12.8 12.8v192.2c0 7 5.7 12.7 12.8 12.7z"
          fill="#f8d275"
        ></path>
      </g>
      <g>
        <path
          d="m137.4 294.5v192.2c0 7.1-5.7 12.8-12.8 12.8h-74.3c-7.1 0-12.8-5.7-12.8-12.8v-192.2c0-7.1 5.7-12.8 12.8-12.8h74.3c7 0 12.8 5.7 12.8 12.8z"
          fill="#f3e379"
        ></path>
      </g>
      <g>
        <g>
          <path
            d="m80.4 377.2c-21.9 4.5-43.2-12.8-42.9-35.3-.3-22.4 21-39.8 42.9-35.2-38.2 7.9-38.2 62.5 0 70.5z"
            fill="#e8ecf0"
          ></path>
        </g>
        <g>
          <path
            d="m80.4 474.4c-21.9 4.5-43.2-12.8-42.9-35.3-.3-22.4 21.1-39.7 42.9-35.2-38.3 8.1-38.2 62.6 0 70.5z"
            fill="#e8ecf0"
          ></path>
        </g>
      </g>
      <g>
        <g>
          <path
            d="m109.3 341.9c0 17.4-12.4 31.9-28.9 35.3-16.5-3.3-28.9-17.8-28.9-35.3 0-17.4 12.4-32 28.9-35.2 16.5 3.3 28.9 17.8 28.9 35.2z"
            fill="#f2f4f6"
          ></path>
        </g>
        <g>
          <path
            d="m109.3 439.2c0 17.4-12.4 31.9-28.9 35.2-16.5-3.3-28.9-17.8-28.9-35.2s12.4-31.9 28.9-35.2c16.5 3.3 28.9 17.8 28.9 35.2z"
            fill="#f2f4f6"
          ></path>
        </g>
      </g>
      <g>
        <g>
          <g>
            <path
              d="m60.3 347.8c-7.7-.3-7.7-11.4 0-11.8 7.7.4 7.7 11.5 0 11.8z"
              fill="#746e77"
            ></path>
          </g>
        </g>
        <g>
          <g>
            <path
              d="m86.4 347.8c-7.7-.3-7.7-11.4 0-11.8 7.7.4 7.7 11.5 0 11.8z"
              fill="#746e77"
            ></path>
          </g>
        </g>
      </g>
      <g>
        <g>
          <g>
            <path
              d="m60.3 445.1c-7.7-.3-7.7-11.4 0-11.8 7.7.4 7.7 11.5 0 11.8z"
              fill="#746e77"
            ></path>
          </g>
        </g>
        <g>
          <g>
            <path
              d="m86.4 445.1c-7.7-.3-7.7-11.4 0-11.8 7.7.4 7.7 11.5 0 11.8z"
              fill="#746e77"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const InsulationDrywallIcon = ({
  size = 36,
  color = "currentColor",
  ...props
}) => (
  <svg
    {...baseProps(size, color, props)}
    viewBox="0 0 512 512"
    fillRule="evenodd"
    clipRule="evenodd"
  >
    <g>
      <path
        fill="#c9c2bb"
        d="M244.117 100.637H72.207a6.5 6.5 0 0 1-6.5-6.5V59.746a6.5 6.5 0 0 1 6.5-6.5h171.91a6.5 6.5 0 0 1 6.5 6.5v34.391a6.5 6.5 0 0 1-6.5 6.5zM460.76 100.637H288.849a6.5 6.5 0 0 1-6.5-6.5V59.746a6.5 6.5 0 0 1 6.5-6.5H460.76a6.5 6.5 0 0 1 6.5 6.5v34.391a6.5 6.5 0 0 1-6.5 6.5z"
        opacity="1"
        data-original="#ff9933"
        class=""
      ></path>
      <path
        fill="#987957"
        d="M72.207 413.46H6.51a6.5 6.5 0 0 1-6.5-6.5V59.746a6.5 6.5 0 0 1 6.5-6.5h65.697a6.5 6.5 0 0 1 6.5 6.5V406.96a6.5 6.5 0 0 1-6.5 6.5z"
        opacity="1"
        data-original="#eeeef0"
        class=""
      ></path>
      <path
        fill="#c2bab2"
        d="M288.849 139.215h-44.73a6.5 6.5 0 0 1-6.5-6.5V59.747a6.5 6.5 0 0 1 6.5-6.5h44.73a6.5 6.5 0 0 1 6.5 6.5v72.968a6.5 6.5 0 0 1-6.5 6.5zM505.49 139.215h-44.73a6.5 6.5 0 0 1-6.5-6.5V59.747a6.5 6.5 0 0 1 6.5-6.5h44.73a6.5 6.5 0 0 1 6.5 6.5v72.968a6.5 6.5 0 0 1-6.5 6.5z"
        opacity="1"
        data-original="#ffc34d"
        class=""
      ></path>
      <path
        fill="#c9c2bb"
        d="M505.49 413.459H244.117a6.5 6.5 0 0 1-6.5-6.5V132.714a6.5 6.5 0 0 1 6.5-6.5H505.49c3.59 0 6.5 2.91 6.5 6.5V406.96c0 3.59-2.91 6.5-6.5 6.5z"
        opacity="1"
        data-original="#ff9933"
        class=""
      ></path>
      <path
        fill="#c2bab2"
        d="M505.49 413.459H244.117a6.5 6.5 0 0 1-6.5-6.5V263.34H511.99v143.62c0 3.59-2.909 6.5-6.5 6.5z"
        opacity="1"
        data-original="#ffc34d"
        class=""
      ></path>
      <g fill="#fff">
        <path
          d="M474.115 179.782c-3.59 0-6.536-2.91-6.536-6.5s2.873-6.5 6.464-6.5h.072a6.5 6.5 0 1 1 0 13zM474.115 207.777c-3.59 0-6.536-2.91-6.536-6.5s2.873-6.5 6.464-6.5h.072a6.5 6.5 0 1 1 0 13zM474.115 235.77c-3.59 0-6.536-2.91-6.536-6.5 0-3.589 2.873-6.5 6.464-6.5h.072a6.5 6.5 0 1 1 0 13zM474.115 316.905c-3.59 0-6.536-2.91-6.536-6.5s2.873-6.5 6.464-6.5h.072a6.5 6.5 0 1 1 0 13zM474.115 344.897c-3.59 0-6.536-2.91-6.536-6.5 0-3.589 2.873-6.5 6.464-6.5h.072a6.5 6.5 0 1 1 0 13zM474.115 372.893c-3.59 0-6.536-2.91-6.536-6.5s2.873-6.5 6.464-6.5h.072a6.5 6.5 0 1 1 0 13z"
          fill="#656565"
          opacity="1"
          data-original="#ffffff"
          class=""
        ></path>
      </g>
      <path
        fill="#635241"
        d="M505.49 458.752H6.511a6.5 6.5 0 0 1-6.5-6.5V406.96a6.5 6.5 0 0 1 6.5-6.5H505.49a6.5 6.5 0 0 1 6.5 6.5v45.292a6.5 6.5 0 0 1-6.5 6.5z"
        opacity="1"
        data-original="#d1d1d6"
        class=""
      ></path>
    </g>
  </svg>
);

export const TrimPaintIcon = ({
  size = 36,
  color = "currentColor",
  ...props
}) => (
  <svg {...baseProps(size, color, props)} viewBox="0 0 512 512">
    <g id="Layer_1" data-name="Layer 1">
      <path
        d="m467.878 463.923a15.019 15.019 0 0 1 -15.02 15.019h-400.552a15.02 15.02 0 1 1 0-30.039h400.552a15.019 15.019 0 0 1 15.02 15.02z"
        fill="#393939"
      ></path>
      <path
        d="m467.766 462.16a14.955 14.955 0 0 1 -14.908 16.783h-400.552a14.955 14.955 0 0 1 -14.906-16.783 15.373 15.373 0 0 0 11.173 4.783h408.019a15.375 15.375 0 0 0 11.174-4.783z"
        fill="#343434"
      ></path>
      <path
        d="m438.876 190.31v258.59h-372.588v-258.59l186.294-140.539z"
        fill="#365e7d"
      ></path>
      <path
        d="m102.036 190.31v258.59h-35.748v-258.59l186.294-140.539z"
        fill="#2b4d66"
      ></path>
      <path
        d="m66.288 190.31 186.294-140.539 186.294 140.539v238.94l-82.239-66.065-22.848-22.848 81.5-81.495-41.32-41.32-18.371 18.371-123.814 128.366h-16.129a13.963 13.963 0 0 0 -13.963 13.963v33.9c0 19.326-26.089 19.326-26.089 0v-47.863c0-25.343-32.3-25.343-32.3 0v33.171c0 19.325-27.331 19.325-27.331 0v-19.208a13.963 13.963 0 0 0 -13.963-13.963h-35.721z"
        fill="#cbf3f9"
      ></path>
      <path
        d="m102.007 197.178v167.081h-35.718v-173.949l186.293-140.539z"
        fill="#ace7f8"
      ></path>
      <path
        d="m420.785 263.964-76.545 76.545 20.4 20.4-9.9 9.9-25.351-25.352a7 7 0 0 1 0-9.9l76.545-76.545-31.42-31.421-17.151 17.15-9.9-9.9 22.1-22.1a7 7 0 0 1 9.9 0l41.32 41.32a7 7 0 0 1 .002 9.903z"
        fill="#6cf"
      ></path>
      <path
        d="m371 348.825-28.719 28.719s75.387 98.607 84.419 107.639a36.726 36.726 0 1 0 51.939-51.938c-9.039-9.033-107.639-84.42-107.639-84.42zm90.668 119.387a12.725 12.725 0 1 1 0-18 12.726 12.726 0 0 1 -.003 18z"
        fill="#ff5959"
      ></path>
      <path
        d="m461.665 468.212 16.971 16.971a36.726 36.726 0 0 1 -51.939 0c-9.032-9.032-84.419-107.639-84.419-107.639l14.359-14.359 87.032 87.031a12.725 12.725 0 0 0 18 18z"
        fill="#e63a57"
      ></path>
      <path d="m302.908 272.47h-93.816v-93.817h93.816z" fill="#6cf"></path>
      <path
        d="m368.06 261.541-113.066 113.067a9.321 9.321 0 0 1 -13.182 0l-24.933-24.933a9.321 9.321 0 0 1 0-13.182l113.066-113.067a9.322 9.322 0 0 1 13.183 0l24.932 24.933a9.321 9.321 0 0 1 0 13.182z"
        fill="#f8ec7d"
      ></path>
      <path
        d="m368.06 261.541-113.066 113.067a9.321 9.321 0 0 1 -13.182 0l-10.547-10.547a7.646 7.646 0 0 0 10.812 0l115.436-115.437a7.645 7.645 0 0 0 0-10.812l10.547 10.547a9.321 9.321 0 0 1 0 13.182z"
        fill="#d7be69"
      ></path>
      <path
        d="m25.683 213.523a14.208 14.208 0 0 1 2.281-19.942l215.8-173.953a16.109 16.109 0 0 1 20.147-.06l213.289 169.885a14.209 14.209 0 0 1 2.241 19.991 14.209 14.209 0 0 1 -19.948 2.236l-205.684-163.821-208.14 167.95a14.208 14.208 0 0 1 -19.986-2.286z"
        fill="#68544f"
      ></path>
      <path
        d="m252.582 48.849-206.913 166.96a14.208 14.208 0 0 1 -19.986-2.286 14.209 14.209 0 0 1 2.281-19.942l215.8-173.954a16.071 16.071 0 0 1 8.823-3.512z"
        fill="#53433f"
      ></path>
      <path
        d="m302.908 232.562h-39.908v39.908h-14v-39.908h-39.908v-14h39.908v-39.909h14v39.909h39.908z"
        fill="#4da6ff"
      ></path>
    </g>
  </svg>
);

export const MechanicalTrimIcon = ({
  size = 36,
  color = "currentColor",
  ...props
}) => (
  <svg {...baseProps(size, color, props)} viewBox="0 0 64 64">
    <path
      d="m37.4 20.8-.907-1.814c-.328-.656-.567-1.352-.711-2.071l-.009-.048c-.49-2.447.155-4.983 1.752-6.9 1.568-1.881 3.891-2.968 6.34-2.967h1.32c.542 0 1.084.045 1.619.134l.818.136c2.784.464 5.235 2.101 6.73 4.494 1.664 2.662 1.959 5.959.793 8.874l-.145.362.706 1.765c.763 1.909.151 4.093-1.494 5.326-.787.59-1.744.909-2.728.909h-3.225c-.824 0-1.632-.224-2.339-.648l-3.44-2.064c-.321-.192-.616-.423-.88-.688l-2.657-2.657c-.626-.627-1.147-1.35-1.543-2.143z"
      fill="#808080"
    ></path>
    <path d="m4 32h28v28h-28z" fill="#039791"></path>
    <path d="m4 4h28v28h-28z" fill="#03aaa5"></path>
    <path d="m32 32h28v28h-28z" fill="#03aaa5"></path>
    <path
      d="m32 20c-6.627 0-12 5.373-12 12h-5c.01-9.385 7.615-16.99 17-17z"
      fill="#039791"
    ></path>
    <path
      d="m20 32c0 6.627 5.373 12 12 12v5c-9.385-.01-16.99-7.615-17-17z"
      fill="#03aaa5"
    ></path>
    <path
      d="m32 44c6.627 0 12-5.373 12-12h5c-.01 9.385-7.615 16.99-17 17z"
      fill="#039791"
    ></path>
    <g fill="#82d1df">
      <path d="m14 60c0-5.523-4.477-10-10-10v-4c7.729.008 13.992 6.271 14 14z"></path>
      <path d="m60 50c-5.523 0-10 4.477-10 10h-4c.008-7.729 6.271-13.992 14-14z"></path>
      <path d="m4 14c5.523 0 10-4.477 10-10h4c-.008 7.729-6.271 13.992-14 14z"></path>
    </g>
    <path
      d="m36 28 3.5-11.213c.872-2.788 3.583-4.58 6.49-4.287 2.914.292 5.218 2.596 5.51 5.51.293 2.907-1.499 5.618-4.287 6.49z"
      fill="#e6e6e6"
    ></path>
    <path
      d="m45.964 13.5h7.071v2h-7.071z"
      fill="#f4e09c"
      transform="matrix(.707 -.707 .707 .707 4.245 39.249)"
    ></path>
    <path
      d="m50.439 6.132h10.607v4.222h-10.607z"
      fill="#c69c6d"
      transform="matrix(.707 -.707 .707 .707 10.498 41.83)"
    ></path>
  </svg>
);

export const FinalFinishesIcon = ({
  size = 36,
  color = "currentColor",
  ...props
}) => (
  <svg {...baseProps(size, color, props)} viewBox="0 0 512 512">
    <g>
      <path
        d="m509.506 195.516-24.403-13.347c-.805-.44-1.466-1.102-1.906-1.906l-13.347-24.403c-1.819-3.326-6.596-3.326-8.415 0l-13.347 24.403c-.44.805-1.102 1.466-1.906 1.906l-24.403 13.347c-3.326 1.819-3.326 6.596 0 8.415l24.403 13.347c.805.44 1.466 1.102 1.906 1.906l13.347 24.403c1.819 3.326 6.596 3.326 8.415 0l13.347-24.403c.44-.805 1.102-1.466 1.906-1.906l24.403-13.347c3.325-1.819 3.325-6.596 0-8.415z"
        fill="#fff0ad"
      ></path>
      <path
        d="m509.506 195.516-24.403-13.347c-.805-.44-1.466-1.102-1.906-1.906l-13.347-24.403c-1.819-3.326-6.596-3.326-8.415 0l-4.039 7.386c9.568 9.903 15.465 23.376 15.465 38.233 0 14.221-5.394 27.182-14.246 36.95l2.821 5.158c1.819 3.326 6.596 3.326 8.415 0l13.347-24.403c.44-.805 1.102-1.466 1.906-1.906l24.403-13.347c3.324-1.819 3.324-6.596-.001-8.415z"
        fill="#ffe177"
      ></path>
      <path
        d="m90.222 104.956-24.403-13.347c-.805-.44-1.466-1.102-1.906-1.906l-13.347-24.404c-1.819-3.326-6.596-3.326-8.415 0l-13.347 24.404c-.44.805-1.102 1.466-1.906 1.906l-24.404 13.347c-3.326 1.819-3.326 6.596 0 8.415l24.403 13.347c.805.44 1.466 1.102 1.906 1.906l13.347 24.403c1.819 3.326 6.596 3.326 8.415 0l13.347-24.403c.44-.805 1.102-1.466 1.906-1.906l24.403-13.347c3.327-1.819 3.327-6.596.001-8.415z"
        fill="#fff0ad"
      ></path>
      <path
        d="m90.222 104.956-24.403-13.347c-.805-.44-1.466-1.102-1.906-1.906l-13.347-24.404c-1.819-3.326-6.596-3.326-8.415 0l-4.039 7.386c9.568 9.903 15.465 23.376 15.465 38.233 0 14.221-5.394 27.182-14.246 36.95l2.821 5.158c1.819 3.326 6.596 3.326 8.415 0l13.347-24.403c.44-.805 1.102-1.466 1.906-1.906l24.403-13.347c3.325-1.818 3.325-6.595-.001-8.414z"
        fill="#ffe177"
      ></path>
      <path
        d="m330.769 53.483-24.403-13.347c-.805-.44-1.466-1.102-1.906-1.906l-13.347-24.403c-1.819-3.326-6.596-3.326-8.415 0l-13.347 24.403c-.44.805-1.102 1.466-1.906 1.906l-24.403 13.347c-3.326 1.819-3.326 6.596 0 8.415l24.403 13.347c.805.44 1.466 1.102 1.906 1.906l13.347 24.403c1.819 3.326 6.596 3.326 8.415 0l13.347-24.403c.44-.805 1.102-1.466 1.906-1.906l24.403-13.347c3.326-1.819 3.326-6.596 0-8.415z"
        fill="#fff0ad"
      ></path>
      <path
        d="m330.769 53.483-24.403-13.347c-.805-.44-1.466-1.102-1.906-1.906l-13.347-24.403c-1.819-3.326-6.596-3.326-8.415 0l-4.039 7.386c9.568 9.903 15.465 23.376 15.465 38.233 0 14.221-5.394 27.182-14.246 36.95l2.821 5.158c1.819 3.326 6.596 3.326 8.415 0l13.347-24.403c.44-.805 1.102-1.466 1.906-1.906l24.403-13.347c3.325-1.819 3.325-6.596-.001-8.415z"
        fill="#ffe177"
      ></path>
      <path d="m121.046 167.404h61.811v122.592h-61.811z" fill="#7a6d79"></path>
      <path d="m151.952 167.404h30.905v122.592h-30.905z" fill="#685e68"></path>
      <path
        d="m189.038 182.857h-74.173c-2.276 0-4.121-1.845-4.121-4.121v-22.664c0-2.276 1.845-4.121 4.121-4.121h74.173c2.276 0 4.121 1.845 4.121 4.121v22.664c0 2.276-1.845 4.121-4.121 4.121z"
        fill="#f3f0f3"
      ></path>
      <path
        d="m189.038 151.952h-30.905c2.276 0 4.121 1.845 4.121 4.121v22.664c0 2.276-1.845 4.121-4.121 4.121h30.905c2.276 0 4.121-1.845 4.121-4.121v-22.664c0-2.276-1.845-4.121-4.121-4.121z"
        fill="#e2dee2"
      ></path>
      <path
        d="m410.53 303.51v171.4h-309.06v-171.39l154.53-118.6z"
        fill="#f3f0f3"
      ></path>
      <path d="m379.622 279.79v195.123h30.905v-171.405z" fill="#e2dee2"></path>
      <path
        d="m442.598 307.611-177.19-135.984c-5.549-4.258-13.267-4.258-18.816 0l-177.19 135.984c-6.77 5.196-8.047 14.897-2.851 21.667s14.897 8.046 21.667 2.851l167.782-128.763 167.782 128.764c2.806 2.153 6.114 3.195 9.397 3.195 4.639 0 9.227-2.081 12.27-6.046 5.196-6.771 3.919-16.472-2.851-21.668z"
        fill="#d6694b"
      ></path>
      <path d="m209.642 349.311h92.716v125.603h-92.716z" fill="#dd7f66"></path>
      <path d="m271.453 349.311h30.905v125.603h-30.905z" fill="#d6694b"></path>
      <path
        d="m309.86 349.31v125.6h-15v-118.1h-77.72v118.1h-15v-125.6c0-4.14 3.36-7.5 7.5-7.5h92.72c4.14 0 7.5 3.36 7.5 7.5z"
        fill="#685e68"
      ></path>
      <path
        d="m276.604 407.147c-4.143 0-7.5 3.357-7.5 7.5v8.242c0 4.143 3.357 7.5 7.5 7.5s7.5-3.357 7.5-7.5v-8.242c0-4.142-3.358-7.5-7.5-7.5z"
        fill="#f3f0f3"
      ></path>
      <path d="m338.387 349.311h41.207v67.992h-41.207z" fill="#a6e7f0"></path>
      <path d="m132.378 349.311h41.207v67.992h-41.207z" fill="#a6e7f0"></path>
      <g fill="#685e68">
        <path d="m379.595 341.811h-41.208c-4.143 0-7.5 3.357-7.5 7.5v67.992c0 4.143 3.357 7.5 7.5 7.5h41.208c4.143 0 7.5-3.357 7.5-7.5v-67.992c0-4.143-3.358-7.5-7.5-7.5zm-7.5 67.992h-26.208v-52.992h26.208z"></path>
        <path d="m173.585 341.811h-41.207c-4.142 0-7.5 3.357-7.5 7.5v67.992c0 4.143 3.358 7.5 7.5 7.5h41.207c4.142 0 7.5-3.357 7.5-7.5v-67.992c0-4.143-3.357-7.5-7.5-7.5zm-7.5 67.992h-26.207v-52.992h26.207z"></path>
      </g>
      <circle cx="256" cy="283.679" fill="#7a6d79" r="30.905"></circle>
      <path
        d="m256 245.273c-21.177 0-38.405 17.229-38.405 38.405s17.229 38.405 38.405 38.405 38.405-17.229 38.405-38.405-17.228-38.405-38.405-38.405zm0 61.811c-12.906 0-23.405-10.5-23.405-23.405s10.5-23.405 23.405-23.405 23.405 10.5 23.405 23.405-10.5 23.405-23.405 23.405z"
        fill="#685e68"
      ></path>
      <path
        d="m496.547 500.668h-481.094c-8.535 0-15.453-6.918-15.453-15.453 0-8.534 6.918-15.453 15.453-15.453h481.095c8.534 0 15.453 6.918 15.453 15.453-.001 8.535-6.919 15.453-15.454 15.453z"
        fill="#57be92"
      ></path>
      <path
        d="m496.547 469.763h-30.905c8.534 0 15.453 6.918 15.453 15.453 0 8.534-6.918 15.453-15.453 15.453h30.905c8.534 0 15.453-6.918 15.453-15.453s-6.918-15.453-15.453-15.453z"
        fill="#22b37f"
      ></path>
    </g>
  </svg>
);

export const PunchListIcon = ({
  size = 36,
  color = "currentColor",
  ...props
}) => (
  <svg {...baseProps(size, color, props)} viewBox="0 0 512 512">
    <g>
      <path
        fill="#76635c"
        d="M375 512H73c-13.807 0-25-11.193-25-25V73c0-13.807 11.193-25 25-25h302c13.807 0 25 11.193 25 25v414c0 13.807-11.193 25-25 25z"
        opacity="1"
        data-original="#fd6930"
        class=""
      ></path>
      <g fill="#fd5426">
        <path
          d="M363 495.453H85a5 5 0 0 1-5-5v-390a5 5 0 0 1 5-5h278a5 5 0 0 1 5 5v390a5 5 0 0 1-5 5z"
          fill="#76635c"
          opacity="1"
          data-original="#fd5426"
          class=""
        ></path>
        <path
          d="M400 164.604h-70.245c-14.224 0-25.755 11.531-25.755 25.755V330.85c0 14.224 11.531 25.755 25.755 25.755H400zM59.396 132.604H48v353.642c0 5.056 1.457 9.771 3.974 13.749 3.406-1.074 6.416-3.569 7.983-7.486l17.465-43.662a36.05 36.05 0 0 0 2.56-12.252l.019-.011V153.207c-.001-11.379-9.226-20.603-20.605-20.603z"
          fill="#76635c"
          opacity="1"
          data-original="#fd5426"
          class=""
        ></path>
      </g>
      <path
        fill="#ffffff"
        d="M363 480H85a5 5 0 0 1-5-5V80h288v395a5 5 0 0 1-5 5z"
        opacity="1"
        data-original="#ffffff"
      ></path>
      <path
        fill="#f2fbff"
        d="M256 52.604c0-17.673-14.327-32-32-32s-32 14.327-32 32h-48.547c-8.534 0-15.453 6.918-15.453 15.453v48.547c0 8.534 6.918 15.453 15.453 15.453h161.095c8.534 0 15.453-6.918 15.453-15.453V68.056c0-8.534-6.918-15.453-15.453-15.453H256z"
        opacity="1"
        data-original="#f2fbff"
      ></path>
      <path
        fill="#f2fbff"
        d="M326.793 80v332.907c0 25.675-20.814 46.489-46.489 46.489H80V475a5 5 0 0 0 5 5h278a5 5 0 0 0 5-5V80z"
        opacity="1"
        data-original="#f2fbff"
      ></path>
      <path
        fill="#515152"
        d="M304 169.091h-64c-4.143 0-7.5-3.358-7.5-7.5s3.357-7.5 7.5-7.5h64c4.143 0 7.5 3.358 7.5 7.5s-3.357 7.5-7.5 7.5zM304 201.091h-64c-4.143 0-7.5-3.358-7.5-7.5s3.357-7.5 7.5-7.5h64c4.143 0 7.5 3.358 7.5 7.5s-3.357 7.5-7.5 7.5zM304 281.091h-64c-4.143 0-7.5-3.358-7.5-7.5s3.357-7.5 7.5-7.5h64c4.143 0 7.5 3.358 7.5 7.5s-3.357 7.5-7.5 7.5zM272 313.091h-32c-4.143 0-7.5-3.358-7.5-7.5s3.357-7.5 7.5-7.5h32c4.143 0 7.5 3.358 7.5 7.5s-3.357 7.5-7.5 7.5zM320 393.091h-80c-4.143 0-7.5-3.358-7.5-7.5s3.357-7.5 7.5-7.5h80c4.143 0 7.5 3.358 7.5 7.5s-3.357 7.5-7.5 7.5z"
        opacity="1"
        data-original="#017297"
        class=""
      ></path>
      <path
        fill="#3a3d3e"
        d="M326.793 388.773c.453-.966.707-2.045.707-3.182s-.254-2.216-.707-3.182z"
        opacity="1"
        data-original="#025f80"
        class=""
      ></path>
      <path
        fill="#515152"
        d="M304 425.091h-64c-4.143 0-7.5-3.358-7.5-7.5s3.357-7.5 7.5-7.5h64c4.143 0 7.5 3.358 7.5 7.5s-3.357 7.5-7.5 7.5z"
        opacity="1"
        data-original="#017297"
        class=""
      ></path>
      <path
        fill="#f2fbff"
        d="M368 164.604h-38.245c-14.224 0-25.755 11.531-25.755 25.755V330.85c0 14.224 11.531 25.755 25.755 25.755H368z"
        opacity="1"
        data-original="#f2fbff"
      ></path>
      <path
        fill="#b4d2e2"
        d="M260.568 32c-2.489 0-4.525-1.876-4.86-4.342C253.589 12.039 240.2 0 224 0s-29.589 12.039-31.708 27.658c-.335 2.466-2.371 4.342-4.86 4.342h-43.98C134.918 32 128 38.918 128 47.453V96c0 8.534 6.918 15.453 15.453 15.453h161.095c8.534 0 15.453-6.918 15.453-15.453V47.453C320 38.918 313.082 32 304.547 32z"
        opacity="1"
        data-original="#b4d2e2"
      ></path>
      <path
        fill="#8abbd5"
        d="M304.547 32h-25.755v22.104c0 20.294-16.451 36.745-36.745 36.745H128V96c0 8.534 6.918 15.453 15.453 15.453h161.095c8.534 0 15.453-6.918 15.453-15.453V47.453C320 38.918 313.082 32 304.547 32z"
        opacity="1"
        data-original="#8abbd5"
      ></path>
      <path
        fill="#fd4755"
        d="M59.396 112H36.604C25.225 112 16 121.225 16 132.604V160l32 16 32-16v-27.396C80 121.225 70.775 112 59.396 112z"
        opacity="1"
        data-original="#fd4755"
        class=""
      ></path>
      <path
        fill="#fb2b3a"
        d="M59.396 112H48.445c.424 1.646.649 3.372.649 5.151v58.302L80 160v-27.396C80 121.225 70.775 112 59.396 112z"
        opacity="1"
        data-original="#fb2b3a"
        class=""
      ></path>
      <path
        fill="#ffdcce"
        d="m48 384-31.981 31.991a36.073 36.073 0 0 0 2.56 12.252l6.211 15.528h46.42l6.211-15.528a36.05 36.05 0 0 0 2.56-12.252z"
        opacity="1"
        data-original="#ffdcce"
        class=""
      ></path>
      <path
        fill="#ffd1be"
        d="M49.095 385.095v15.432l-.019.011a36.073 36.073 0 0 1-2.56 12.252l-12.392 30.981H71.21l6.211-15.528a36.05 36.05 0 0 0 2.56-12.252z"
        opacity="1"
        data-original="#ffd1be"
        class=""
      ></path>
      <path
        fill="#515152"
        d="m59.956 471.905 11.254-28.134c-6.879-3.807-14.791-5.975-23.21-5.975s-16.331 2.168-23.21 5.975l11.254 28.134c4.317 10.793 19.595 10.793 23.912 0z"
        opacity="1"
        data-original="#017297"
        class=""
      ></path>
      <path
        fill="#01c0fa"
        d="m79.981 415.991.019-.011V160H16v255.979l.019.011 20.464-10.232a25.757 25.757 0 0 1 23.036 0z"
        opacity="1"
        data-original="#01c0fa"
      ></path>
      <path
        fill="#3a3d3e"
        d="M48 437.796c-4.181 0-8.236.535-12.102 1.539l-6.441 16.103 6.587 16.468c4.317 10.793 19.595 10.793 23.912 0l11.254-28.134A47.775 47.775 0 0 0 48 437.796z"
        opacity="1"
        data-original="#025f80"
        class=""
      ></path>
      <path
        fill="#08a9f1"
        d="M49.095 160v240.527l-.019.011a36.512 36.512 0 0 1-.168 2.519 25.744 25.744 0 0 1 10.61 2.702l20.464 10.232.019-.011V160z"
        opacity="1"
        data-original="#08a9f1"
      ></path>
      <path
        fill="#01c0fa"
        d="M471 336H329c-13.807 0-25-11.193-25-25V169c0-13.807 11.193-25 25-25h142c13.807 0 25 11.193 25 25v142c0 13.807-11.193 25-25 25z"
        opacity="1"
        data-original="#01c0fa"
      ></path>
      <path
        fill="#08a9f1"
        d="M496 169.755C496 155.531 484.469 144 470.245 144h-5.666a25.86 25.86 0 0 1 .515 5.151v115.075c0 28.261-22.91 51.17-51.17 51.17H304.515c2.387 11.756 12.78 20.604 25.24 20.604h140.491C484.469 336 496 324.469 496 310.246z"
        opacity="1"
        data-original="#08a9f1"
      ></path>
      <path
        fill="#fac600"
        d="m448 256-48 16-48-16v-21.746C352 210.918 370.918 192 394.254 192h11.492C429.082 192 448 210.918 448 234.254z"
        opacity="1"
        data-original="#fac600"
        class=""
      ></path>
      <path
        fill="#fed402"
        d="m416 256-16 16-16-16v-64a5.15 5.15 0 0 1 5.151-5.151h21.698A5.15 5.15 0 0 1 416 192z"
        opacity="1"
        data-original="#fed402"
        class=""
      ></path>
      <path
        fill="#fedf30"
        d="M451.498 256H348.501c-5.744 0-9.479 6.044-6.911 11.182l1.774 3.548A31.242 31.242 0 0 0 371.307 288h57.383a31.242 31.242 0 0 0 27.943-17.27l1.774-3.548c2.571-5.137-1.165-11.182-6.909-11.182z"
        opacity="1"
        data-original="#fedf30"
        class=""
      ></path>
      <path
        fill="#97d729"
        d="m182.532 146.263-24.942 24.942a5 5 0 0 1-7.071 0l-13.628-13.628a7.727 7.727 0 0 0-10.927 0l-11.701 11.701a7.727 7.727 0 0 0 0 10.927l34.328 34.328a7.727 7.727 0 0 0 10.927 0l45.642-45.642a7.727 7.727 0 0 0 0-10.927l-11.701-11.701a7.727 7.727 0 0 0-10.927 0zM182.532 258.263l-24.942 24.942a5 5 0 0 1-7.071 0l-13.628-13.628a7.727 7.727 0 0 0-10.927 0l-11.701 11.701a7.727 7.727 0 0 0 0 10.927l34.328 34.328a7.727 7.727 0 0 0 10.927 0l45.642-45.642a7.727 7.727 0 0 0 0-10.927l-11.701-11.701a7.727 7.727 0 0 0-10.927 0zM182.532 363.058 157.59 388a5 5 0 0 1-7.071 0l-13.628-13.628a7.727 7.727 0 0 0-10.927 0l-11.701 11.701a7.727 7.727 0 0 0 0 10.927l34.328 34.328a7.727 7.727 0 0 0 10.927 0l45.642-45.642a7.727 7.727 0 0 0 0-10.927l-11.701-11.701a7.727 7.727 0 0 0-10.927 0z"
        opacity="1"
        data-original="#97d729"
        class=""
      ></path>
      <circle
        cx="224"
        cy="32"
        r="7.5"
        fill="#8abbd5"
        opacity="1"
        data-original="#8abbd5"
      ></circle>
      <path
        fill="#8abbd5"
        d="M288 87.5H160c-4.143 0-7.5-3.358-7.5-7.5s3.357-7.5 7.5-7.5h128c4.143 0 7.5 3.358 7.5 7.5s-3.357 7.5-7.5 7.5z"
        opacity="1"
        data-original="#8abbd5"
      ></path>
      <path
        fill="#6cabca"
        d="M288 72.5h-14.137a36.892 36.892 0 0 1-16.469 15H288c4.143 0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5z"
        opacity="1"
        data-original="#6cabca"
        class=""
      ></path>
      <path
        fill="#ffffff"
        d="M40.5 404.157a25.76 25.76 0 0 1 15 0V160h-15z"
        opacity="1"
        data-original="#ffffff"
      ></path>
      <path
        fill="#f2fbff"
        d="M55.5 160h-6.406v240.527l-.019.011a36.512 36.512 0 0 1-.168 2.519c2.224.078 4.441.445 6.592 1.1V160z"
        opacity="1"
        data-original="#f2fbff"
      ></path>
    </g>
  </svg>
);

export const FinalInspectionIcon = ({
  size = 36,
  color = "currentColor",
  ...props
}) => (
  <svg {...baseProps(size, color, props)} viewBox="0 0 64 64">
    <g>
      <path
        fill="#ffffff"
        d="M48 5H14a1.003 1.003 0 0 0-1 1v49a1.003 1.003 0 0 0 1 1h32l1-.75 1 .75a1.003 1.003 0 0 0 1-1V6a1.003 1.003 0 0 0-1-1z"
        opacity="1"
        data-original="#fafafa"
        class=""
      ></path>
      <path
        fill="#78909c"
        d="M30 38a1 1 0 0 1-1 1H19a1 1 0 0 1 0-2h10a1 1 0 0 1 1 1z"
        opacity="1"
        data-original="#78909c"
        class=""
      ></path>
      <path
        fill="#cfd8dc"
        d="M18 43a1 1 0 0 1 1-1h15a1 1 0 0 1 0 2H19a1 1 0 0 1-1-1zm16 3H19a1 1 0 0 0 0 2h15a1 1 0 0 0 0-2z"
        opacity="1"
        data-original="#cfd8dc"
        class=""
      ></path>
      <path
        fill="#eeeeee"
        d="M39 16.9v16.2a.957.957 0 0 1-1 .9H24a.957.957 0 0 1-1-.9V16.9a.957.957 0 0 1 1-.9h14a.957.957 0 0 1 1 .9z"
        opacity="1"
        data-original="#eeeeee"
        class=""
      ></path>
      <path
        fill="#ffa000"
        d="M31 24a3 3 0 1 1 3-3 3.003 3.003 0 0 1-3 3zm3 1h-6a1.003 1.003 0 0 0-1 1v8h8v-8a1.003 1.003 0 0 0-1-1zm7.447-9.895-10-5a1.001 1.001 0 0 0-.894 0l-10 5A1 1 0 0 0 20 16v4a1 1 0 0 0 1.447.895L31 16.118l9.553 4.777a.984.984 0 0 0 .973-.044A1 1 0 0 0 42 20v-4a1 1 0 0 0-.553-.895zM52 48v9a1.018 1.018 0 0 1-.55.89 1.029 1.029 0 0 1-1.05-.09L48 56l-1-.75-1 .75-2.4 1.8a.996.996 0 0 1-1.05.09A.977.977 0 0 1 42 57v-9a1.003 1.003 0 0 1 1-1h8a1.003 1.003 0 0 1 1 1z"
        opacity="1"
        data-original="#ffa000"
        class=""
      ></path>
      <path
        fill="#f44336"
        d="M55 42a8 8 0 1 1-8-8 8.01 8.01 0 0 1 8 8z"
        opacity="1"
        data-original="#f44336"
      ></path>
      <path
        fill="#ffa000"
        d="M52 42a5 5 0 1 1-5-5 5.006 5.006 0 0 1 5 5z"
        opacity="1"
        data-original="#ffa000"
        class=""
      ></path>
    </g>
  </svg>
);

export const CompleteIcon = ({
  size = 36,
  color = "currentColor",
  ...props
}) => (
  <svg {...baseProps(size, color, props)} viewBox="0 0 64 64">
    <g id="_16-House_Key" data-name="16-House Key">
      <path d="m6 45h42v4h-42z" fill="#ef5350"></path>
      <path d="m48 45v4h-42v-2h34a2 2 0 0 0 2-2z" fill="#e53935"></path>
      <path
        d="m27 3a2.90031 2.90031 0 0 0 -1.7875.61631l-22.2125 17.38369 2.81 3.58 21.19-16.58 21.19 16.58 2.81-3.58-22.2125-17.38369a2.90031 2.90031 0 0 0 -1.7875-.61631z"
        fill="#ef5350"
      ></path>
      <path d="m45 16.304v-13.304h-8v7.043z" fill="#757575"></path>
      <path d="m45 22.08v22.92h-36v-22.92l18-14.08z" fill="#eee"></path>
      <path
        d="m44.946 22.038-17.946-14.038-18 14.08v3.813l18-14.084 15 11.736v21.455h3v-22.92z"
        fill="#e0e0e0"
      ></path>
      <path
        d="m29 27h11v9h-11z"
        fill="#64b5f6"
        transform="matrix(-1 0 0 -1 69 63)"
      ></path>
      <path d="m40 27v9h-11v-3h4a4 4 0 0 0 4-4v-2z" fill="#42a5f5"></path>
      <path d="m14 27h10v18h-10z" fill="#757575"></path>
      <path d="m24 27v18h-10v-3h3a4 4 0 0 0 4-4v-11z" fill="#616161"></path>
      <path
        d="m51 29a9.97682 9.97682 0 0 0 -9.39587 13.39587l-12.60413 12.60413v6h6v-4h4v-4h4l4.60413-4.60413a9.99593 9.99593 0 1 0 3.39587-19.39587z"
        fill="#ffb74d"
      ></path>
      <circle cx="53" cy="37" fill="#eee" r="3"></circle>
      <path
        d="m56.41 30.59a9.96711 9.96711 0 0 1 1.53675 6.45781 10.07848 10.07848 0 0 1 -7.26407 8.57584 9.8691 9.8691 0 0 1 -6.08268-.22365l-11.42843 11.42842a4 4 0 0 1 -2.82843 1.17158h-1.34314v3h6v-4h4v-4h4l4.6-4.6a9.88982 9.88982 0 0 0 5.40681.3901 10.09654 10.09654 0 0 0 7.96441-9.02134 9.99373 9.99373 0 0 0 -4.56122-9.17876z"
        fill="#ffa726"
      ></path>
      <path d="m37 6.234v3.809l8 6.261v-3.809z" fill="#616161"></path>
    </g>
  </svg>
);

export const PHASE_ICONS = {
  "In Development": InDevelopmentIcon,
  "Planning/Permitting": PlanningPermittingIcon,
  Foundation: FoundationIcon,
  Framing: FramingIcon,
  "Rough-In": RoughInIcon,
  "Insulation & Drywall": InsulationDrywallIcon,
  "Trim & Paint": TrimPaintIcon,
  "Mechanical Trim": MechanicalTrimIcon,
  "Final Finishes": FinalFinishesIcon,
  "Punch List": PunchListIcon,
  "Final Inspection / CO": FinalInspectionIcon,
  Complete: CompleteIcon,
};

export const PhaseIcon = ({
  phase,
  size = 36,
  color = "currentColor",
  ...props
}) => {
  const Icon = PHASE_ICONS[phase];
  if (!Icon) return null;
  return <Icon size={size} color={color} {...props} />;
};
